import { Routes } from '@angular/router';
import { authGuard } from './guards/auth-guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./components/login/login').then(m => m.Login)
  },
  {
    path: 'accounts',
    canActivate: [authGuard],
    loadComponent: () => import('./components/accounts/accounts').then(m => m.Accounts),
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./components/dashboard/dashboard').then(m => m.Dashboard),
    canActivate: [authGuard]
  },
  {
    path: 'menu',
    loadComponent: () => import('./components/menu/menu').then(m => m.Menu),
    canActivate: [authGuard]
  },
  {
    path: 'orders',
    loadComponent: () => import('./components/orders/orders').then(m => m.Orders),
    canActivate: [authGuard]
  },
  {
    path: 'broadcast',
    loadComponent: () => import('./components/broadcast/broadcast').then(m => m.BroadcastComponent),
    canActivate: [authGuard]
  },
  {
    path: 'purchase-orders',
    loadComponent: () => import('./components/purchase-orders/purchase-orders').then(m => m.PurchaseOrders),
    canActivate: [authGuard]
  },
  {
    path: 'vendors',
    loadComponent: () => import('./components/vendors/vendors').then(m => m.Vendors),
    canActivate: [authGuard]
  },
  {
    path: 'inventory',
    loadComponent: () => import('./components/inventory/inventory').then(m => m.Inventory),
    canActivate: [authGuard]
  },
  {
    path: 'food-planning',
    loadComponent: () => import('./components/food-planning/food-planning').then(m => m.FoodPlanning),
    canActivate: [authGuard]
  },
  {
    path: 'counter',
    loadComponent: () => import('./components/counter/counter-dashboard').then(m => m.CounterDashboard),
    canActivate: [authGuard]
  },
  {
    path: 'counter/kot',
    loadComponent: () => import('./components/counter/kot-placement').then(m => m.KOTPlacement),
    canActivate: [authGuard]
  },
  {
    path: 'counter/closing',
    loadComponent: () => import('./components/counter/counter-closing').then(m => m.CounterClosing),
    canActivate: [authGuard]
  },
  {
    path: 'counter/history',
    loadComponent: () => import('./components/counter/counter-history').then(m => m.CounterHistory),
    canActivate: [authGuard]
  },
  {
    path: 'recipes',
    loadComponent: () => import('./components/recipe-cards/recipe-cards').then(m => m.RecipeCards),
    canActivate: [authGuard]
  },
  {
    path: 'ledger',
    loadComponent: () => import('./components/ledger/ledger').then(m => m.Ledger),
    canActivate: [authGuard]
  },
  {
    path: 'accounts-ledger',
    loadComponent: () => import('./components/accounts-ledger/accounts-ledger').then(m => m.AccountsLedger),
    canActivate: [authGuard]
  },
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/dashboard'
  }
];
